// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.active[data-v-78bf93e9] {\n  box-shadow: 0px 2px 10px 3px rgba(120,120,120,0.75);\n  background: #385F73;\n  color: white !important;\n}\n.truncate[data-v-78bf93e9] {\n  display:inline;\n  width:20px;\n  white-space:nowrap;\n  overflow:hidden;\n  text-overflow:ellipsis\n}\n[data-v-78bf93e9] .wrap-header {\n  line-height: 1.5;\n}\n", ""]);
// Exports
module.exports = exports;
